module.exports = __webpack_public_path__ + "img/sumary_total_co2.c3a8ee9d.svg";